import { toast } from "react-toastify";
import { debugLog } from "./debugLog";

export const encryptFileWithIV = async (file, ivKey, spaceKey) => {
  if (!file) return toast.error("No file selected.");

  if (ivKey.length !== 16 || spaceKey.length !== 16) {
    return toast.error("IV and Space Key must be exactly 16 characters.");
  }

  const arrayBuffer = await file.arrayBuffer();

  const iv = new TextEncoder().encode(spaceKey); // 16 bytes

  const key = new TextEncoder().encode(ivKey); // 16 bytes = AES-128-CBC

  try {
    const cryptoKey = await crypto.subtle.importKey(
      "raw",

      key,

      { name: "AES-CBC" },

      false,

      ["encrypt"]
    );

    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: "AES-CBC", iv },

      cryptoKey,

      arrayBuffer
    );

    const blob = new Blob([encryptedBuffer], { type: file.type });
    return blob;
  } catch (err) {
    console.error(err);

    toast.error("Encryption failed.");
  }
};
export const decryptFileWithIV = async (
  encryptedFile,
  name,
  ext,
  ivKey,
  spaceKey
) => {
  console.log("🚀 ~ decryptFileWithIV ~ encryptedFile:", encryptedFile);
  if (!encryptedFile) return toast.error("No file selected.");

  if (ivKey.length !== 16 || spaceKey.length !== 16) {
    return toast.error("IV and Space Key must be exactly 16 characters.");
  }

  try {
    const encryptedBuffer = await encryptedFile.arrayBuffer();

    const iv = new TextEncoder().encode(spaceKey); // IV
    const key = new TextEncoder().encode(ivKey); // Key

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      key,
      { name: "AES-CBC" },
      false,
      ["decrypt"]
    );

    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv },
      cryptoKey,
      encryptedBuffer
    );

    const blob = new Blob([decryptedBuffer], { type: encryptedFile.type });
    debugLog("🚀 ~ decryptFileWithIV ~ blob:", "log", blob);

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // ✅ Set filename using provided name and ext
    const fileName = `${name}`;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    return blob;
  } catch (err) {
    console.error(err);
    toast.error(
      "❌ Decryption failed. Possibly wrong key/IV or corrupted file."
    );
  }
};
